import { reactive } from "vue";

export function createCountdown(targetTime) {
    let intervalId = null;

    const getRemainingMs = () => {
        const targetTimestamp =
            targetTime instanceof Date
                ? targetTime.getTime()
                : new Date(targetTime).getTime();

        return Math.max(0, targetTimestamp - Date.now());
    };

    const timer = reactive({
        remainingMs: getRemainingMs(),

        start() {
            if (intervalId !== null) {
                return;
            }

            this.remainingMs = getRemainingMs();

            intervalId = setInterval(() => {
                this.remainingMs = getRemainingMs();

                if (this.remainingMs <= 0) {
                    this.pause();
                    this.remainingMs = 0;
                }
            }, 200);
        },

        pause() {
            if (intervalId === null) {
                return;
            }

            clearInterval(intervalId);
            intervalId = null;
        },

        reset(newTargetTime) {
            if (newTargetTime !== undefined) {
                targetTime = newTargetTime;
            }

            this.remainingMs = getRemainingMs();
        },

        get totalSeconds() {
            return Math.floor(this.remainingMs / 1000);
        },

        get hours() {
            return Math.floor(this.totalSeconds / 3600);
        },

        get minutes() {
            return Math.floor((this.totalSeconds % 3600) / 60);
        },

        get seconds() {
            return this.totalSeconds % 60;
        },

        get isExpired() {
            return this.remainingMs <= 0;
        },

        get isRunning() {
            return intervalId !== null;
        }
    });

    timer.start();

    return timer;
}